<template>
  <div>
      <b-form-group
          :label="$t('message.Subject_uz')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="subject.subject_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Subject_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="subject.subject_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Subject_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="subject.subject_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Subject_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="subject.subject_kr"
            required
        />
      </b-form-group>
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
  </div>
</template>

<script>

import {addSubject, editSubject, getSubjectNameById} from "../../../../../../api/subject";
export default {
  name: "SubjectModal",
  props: {
    activeModal: {
      type: Boolean,
      required:true
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      subject: {
        subject_uz: '',
        subject_ru: '',
        subject_en: '',
        subject_kr: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchSubjects(){
      getSubjectNameById({ id: this.id}).then(response => {
        this.subject = response.data.data
      })
    },
    handleSubmit() {
      if (this.subject.subject_uz
          && this.subject.subject_ru
          && this.subject.subject_en
          && this.subject.subject_kr) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editSubject(this.subject).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addSubject(this.subject).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchSubjects()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
